import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './style.scss'
import { SupportedChainId } from 'constants/chain'
import { useDispatch, useSelector } from 'react-redux'
import { getChainId, getWalletType, setChainId } from 'wallet/wallet'
import { accessToken } from 'utils/sendRequest'
import { setChainID } from 'store/wallet/walletSlice'
import { switchChain } from 'wallet/ether'
import { selectWallet } from 'store/wallet/selectors'

const chains = [
  Number(process.env.REACT_APP_CHAINID_ETHEREUM),
  Number(process.env.REACT_APP_CHAINID_BINANCE),
  Number(process.env.REACT_APP_CHAINID_POLYGON),
]

export default function NetworkPanel() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { chainId } = useSelector(selectWallet)
  const [focus, setFocus] = useState<number | string | undefined>(undefined)

  async function setChain() {
    let chainId = process.env
      .REACT_APP_CHAINID_ETHEREUM as unknown as SupportedChainId
    if (focus !== undefined || !chainId) return
    chainId = Number(chainId)
    try {
      setFocus(chainId)
      const type = getWalletType()
      if (type && accessToken()) {
        await switchChain(chainId)
      } else {
        dispatch(setChainID(chainId))
      }
    } catch (error) {
      console.error(error)
    } finally {
      setFocus(undefined)
    }
  }

  useEffect(() => {
    if (chainId !== undefined) {
      setChainId(chainId)
    } else {
      let chain = getChainId()
      chain = chain ? Number(chain) : undefined
      chain = (
        process.env.REACT_APP_CHAINID_ETHEREUM
          ? Number(process.env.REACT_APP_CHAINID_ETHEREUM)
          : undefined
      ) as SupportedChainId | undefined
      dispatch(setChainID(chain))
    }
  }, [chainId])

  return (
    <>
      {!chains.includes(chainId || 0) ? (
        <div className='network-panel'>
          {t('SWITCH_NETWORK_ERROR')} |{' '}
          <a onClick={setChain}>{t('SWITCH_BACK_TO_NETWORK')}</a>
        </div>
      ) : (
        <></>
      )}
    </>
  )
}
